import { render, staticRenderFns } from "./OrdenCompraList.vue?vue&type=template&id=2f936f8b&scoped=true&"
import script from "./OrdenCompraList.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraList.vue?vue&type=script&lang=js&"
import style0 from "./OrdenCompraList.vue?vue&type=style&index=0&id=2f936f8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f936f8b",
  null
  
)

export default component.exports